export default __webpack_public_path__ + "static/media/Shayan.3760aed1.jpeg";